/**
 * Burger Menu Button
 * Animated hamburger/close icon
 */
import { motion } from 'framer-motion';
import styles from './BurgerButton.module.css';

interface BurgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export function BurgerButton({ isOpen, onClick }: BurgerButtonProps) {
  return (
    <button
      className={`${styles.button} ${isOpen ? styles.active : ''}`}
      onClick={onClick}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" className={styles.icon}>
        <motion.line
          x1="3"
          y1="6"
          x2="21"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          animate={
            isOpen
              ? { rotate: 45, y: 6, x: 0, originX: '12px', originY: '12px' }
              : { rotate: 0, y: 0, x: 0 }
          }
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        />
        <motion.line
          x1="3"
          y1="12"
          x2="21"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          animate={isOpen ? { opacity: 0, x: 20 } : { opacity: 1, x: 0 }}
          transition={{ duration: 0.15 }}
        />
        <motion.line
          x1="3"
          y1="18"
          x2="21"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          animate={
            isOpen
              ? { rotate: -45, y: -6, x: 0, originX: '12px', originY: '12px' }
              : { rotate: 0, y: 0, x: 0 }
          }
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        />
      </svg>
    </button>
  );
}


